import { useState, useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import LayoutProvider from "../../../../../providers/LayoutProvider";
import BreadCrumb from "../../../../../components/Training/common/BreadCrumb";
import { API_STATUS, ENDORSEMENT_TEMPLATES, ROLES } from "../../../../../constants";
import { Link, useNavigate } from "react-router-dom";
import templates from "../templates";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import useCustomToast from "../../../../../hooks/useCustomToast";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ICreateEndorsementInput } from "../../../../../types/endorsement.types";
import { getEndorsementEntryData, getEndorsementExpiryData, getTemplateText, resetEndorsementValues } from "../../../../../store/slices/endorsement.slice";
import EndorsementService from "../../../../../services/endorsement.service";
import { Toaster } from "react-hot-toast";
import "../style.scss"
import { getInstructors, getInstructorsFromApi, getStudents, getStudentsFromApi, getUserApiStatus, setStatusForStudentInstructor } from "../../../../../store/slices/instructor-student.slice";
import SpinnerLoader from "../../../../../components/SpinnerLoader";
import { confirmAlert } from "react-confirm-alert";
const initialState: ICreateEndorsementInput = {
  instructorId: "",
  studentId: "",
  name: "",
  entryDate: "",
  expiryDate: "",
  text: "",
  status: false,
  byInstructor: false
}

function CreateEndorsement() {
  const [selectedTemplate, setSelectedTemplate] = useState<number>(0);
  const [formData, setFormData] = useState<ICreateEndorsementInput>(initialState)

  const customToast = useCustomToast()
  const navigate = useNavigate()

  const instructors = useSelector(getInstructors)
  const students = useSelector(getStudents)
  const templateText = useSelector(getTemplateText)
  const entryDate = useSelector(getEndorsementEntryData)
  const expiryDate = useSelector(getEndorsementExpiryData)
  const loading = useSelector(getUserApiStatus)
  const user = useSelector(getUser)

  const dispatch = useDispatch()

  useEffect(() => {
    setFormData((prev) => ({ ...prev, text: templateText, name: ENDORSEMENT_TEMPLATES[selectedTemplate]?.name, entryDate, expiryDate }))
  }, [user, templateText, selectedTemplate, entryDate, expiryDate,])

  useEffect(() => {
    if (user?.role === ROLES.STUDENT) {
      dispatch(getInstructorsFromApi())
    } else {
      dispatch(getStudentsFromApi())
    }
  }, [dispatch])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (user?.role === ROLES.STUDENT && !formData.instructorId) return customToast(`Please select an instructor`, "error")
    if (user?.role === ROLES.INSTRUCTOR && !formData.studentId) return customToast(`Please select an student`, "error")
    if (!formData.name) return customToast("Please select an endorsement template", "error")
    if (!formData.entryDate) return customToast("Please add entry date", "error")
    if (!formData.expiryDate) return customToast("Please add expiry date", "error")
    if (user?.role === ROLES.INSTRUCTOR) {
      formData.byInstructor = true
    } else {
      formData.studentId = user?._id
    }
    confirmAlert({
      title: 'Confirm',
      message: `Are you sure you want to create this endorsement?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
            const res: any = await EndorsementService.create(formData)
            if (res?.response?.status >= 400) {
              customToast(res?.response?.data?.error, "error")
              dispatch(setStatusForStudentInstructor(API_STATUS.FAILED))
              return
            }
            if (res?.status === 201) {
              dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
              customToast("Endorsement created successfully", "success")
              dispatch(resetEndorsementValues(null))
              setFormData(initialState)
              setTimeout(() => {
                navigate("/training/endorsement")
              }, 2500)
            }
          },
        },
        {
          label: 'No',
          onClick: () => { },
        },
      ],
    })
  }

  return (
    <LayoutProvider>
      {loading === API_STATUS.LOADING && <SpinnerLoader />}
      <div className="create_endorsement">
        <Toaster />
        <div className="label_row">
          <h2 className="heading2">Add Endorsement</h2>
          <BreadCrumb links={["Dashboard", "Training", "Add Endorsement "]} />
        </div>
        <div className="form__wrapper">
          <h3 className="heading3">Add New Endorsement</h3>
          <form action="">
            <div className="row">
              {user?.role === ROLES.STUDENT ? <div className="col-lg-6 col-md-12">
                <label className="form-label">
                  <div>Choose an Instructor</div>
                </label>
                <select
                  id="inputState"
                  className="form-select"
                  placeholder="Select Instructor"
                  name="instructorId"
                  value={formData.instructorId}
                  onChange={(e) => setFormData((prev) => ({ ...prev, instructorId: e.target.value }))}
                >
                  <option value="">Select Instructor</option>
                  {instructors?.map((instructor: any, i: number): React.ReactElement => {
                    return (
                      <option value={instructor?.userId._id} key={i}>{instructor?.userId.firstname} {instructor?.userId.lastname}</option>
                    )
                  })}
                </select>
              </div> :
                <div className="col-lg-6 col-md-12">
                  <label className="form-label">
                    <div>Choose an Student</div>
                  </label>
                  <select
                    id="inputState"
                    className="form-select"
                    placeholder="Select Instructor"
                    name="studentId"
                    value={formData.studentId}
                    onChange={(e) => setFormData((prev) => ({ ...prev, studentId: e.target.value }))}
                  >
                    <option value="">Select Student</option>
                    {students?.map((student: any, i: number): React.ReactElement => {
                      return (
                        <option value={student?.userId._id} key={i}>{student?.userId.firstname} {student?.userId.lastname}</option>
                      )
                    })}
                  </select>
                </div>}
              <div className="col-lg-6 col-md-12 mt-2">
                <label className="form-label">Pick an endorsement Template</label>
                <select
                  id="inputState"
                  className="form-select"
                  placeholder="Custom Endorsement"
                  onChange={(e) => setSelectedTemplate(parseInt(e.target.value))}
                >
                  {ENDORSEMENT_TEMPLATES.map((template) => (
                    <option
                      key={template.id}
                      value={template.id}
                      selected={template.id === 0}
                    >
                      {template.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <h4 className="heading4 mt-3">Fill in the template</h4>

            {templates.map((temp: any) => {
              if (temp.templateId === selectedTemplate) {
                return temp.getTemplate(
                  ENDORSEMENT_TEMPLATES.filter(
                    (t) => t.id === selectedTemplate
                  )[0]?.name || ""
                );
              }
              return null;
            })}

            <div className="d-flex justify-content-end" style={{ marginTop: -70, marginRight: 20 }}>
              <button className="button" onClick={handleSubmit}>Add Endorsement</button>
            </div>
          </form>
        </div>
      </div>
    </LayoutProvider>
  );
}

export default CreateEndorsement;
